AppConfig.$inject = ["$authProvider", "$httpProvider"];

import {
    WebStorageStateStore
} from "oidc-client";

function AppConfig(authProvider, httpProvider) {

    // httpProvider.interceptors.push('authHttpResponseInterceptor');
    authProvider.configure({
        authority: openId,
        client_id: client_id,
        response_type: "id_token token",
        scope: "openid profile email phone midTinetApi",
        userStore: new WebStorageStateStore({
            store: window.localStorage
        }),
        redirectCallback: `${location.origin + location.pathname}#!/Authentication/Callback`
    });
}

export default AppConfig;